import React from 'react';

import { useParams } from 'react-router';

import { TagFormComp, TagListComp } from './components';

import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';

export function TagListArquivo() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();
    if (!hasPermission(['ARQUIVO_MODERAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <TagListComp />
        </ListagemProvider>
    );
}

export function TagFormArquivo() {
    const { id } = useParams();
    const { hasPermission, alertNotPermission } = usePermissionsContext();
    if (!hasPermission(['ARQUIVO_MODERAR'])) return alertNotPermission();

    return (
        <FormProvider>
            <TagFormComp />
        </FormProvider>
    );
}
